'use client'

import { ColumnDef } from '@tanstack/react-table'
import { KPIGoalPlanTableModel } from '@/types/targets'

import {
  DataTableColumnCell,
  DataTableColumnHeader,
} from '@/components/ui/data-table'

export const kpiGoalPlanTableColumns: ColumnDef<KPIGoalPlanTableModel>[] = [
  // {
  //   accessorKey: 'kpiId',
  //   header: ({ column }) => {
  //     return DataTableColumnHeader({
  //       column,
  //       title: 'KPI ID',
  //     })
  //   },
  //   cell: ({ row }) => {
  //     return DataTableColumnCell({
  //       row,
  //       accessorKey: 'kpiId',
  //     })
  //   },
  //   enableSorting: true,
  // },
  {
    accessorKey: 'branch',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'BRANCH',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'branch',
      })
    },
  },
  // {
  //   accessorKey: 'area',
  //   header: ({ column }) => {
  //     return DataTableColumnHeader({
  //       column,
  //       title: 'AREA',
  //     })
  //   },
  //   cell: ({ row }) => {
  //     return DataTableColumnCell({
  //       row,
  //       accessorKey: 'area',
  //     })
  //   },
  // },
  {
    accessorKey: 'kpiName',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'KPI NAME',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'kpiName',
      })
    },
  },
  {
    accessorKey: 'description',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'DESCRIPTION',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'description',
      })
    },
  },
  {
    accessorKey: 'calculation',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'CALCULATION',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'calculation',
      })
    },
  },
  {
    accessorKey: 'target',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'TARGET',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'target',
      })
    },
  },
  {
    accessorKey: 'achievement',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'ACHIEVEMENT',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'achievement',
      })
    },
  },
  {
    accessorKey: 'bonus',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'BONUS',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'bonus',
      })
    },
  },
  {
    accessorKey: 'action',
    header: ({ column }) => {
      return DataTableColumnHeader({
        column,
        title: 'ACTION',
      })
    },
    cell: ({ row }) => {
      return DataTableColumnCell({
        row,
        accessorKey: 'action',
      })
    },
  },
]
